<template>
  <div id="keyword">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>商品管理&nbsp;/&nbsp;关键词管理</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS'></Provinces>
           <el-input class="elinputs" v-model="beginData.keyword" placeholder="请输入关键词"></el-input>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click='resets'>重置</el-button>
        </div>
        <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="keyword" label="关键词" min-width="130"></el-table-column>
            <el-table-column prop="areasName" label="所属地区" width="160"></el-table-column>
            <el-table-column label="是否默认" width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.isDefault" style="color:#67C23A">是</p>
                    <p class="boldfont" v-else style="color:#F56C6C">否</p>
                </template>
            </el-table-column>
            <el-table-column label="是否热门" width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.isHot" style="color:#67C23A">是</p>
                    <p class="boldfont" v-else style="color:#F56C6C">否</p>
                </template>
            </el-table-column>
            <el-table-column prop="sortOrder" label="排序" sortable width="100"></el-table-column>
            <el-table-column prop="addTime" label="创建时间" width="180"></el-table-column>
            <el-table-column prop="updateTime" label="更新时间" width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(1,scope.row,'keyword:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'keyword:delete')"><i class="el-icon-delete"></i> 删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog title="添加/编辑" :visible.sync="dialogFormVisible" width="60%" @close="dataClose">
        <el-form>
            <el-form-item label="* 关键词：">
               <el-input placeholder="请输入关键词" v-model="mydata.keyword" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 所属地区：" class="keyword">
                <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                    <el-option
                    v-for="item in shenglist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="shi" placeholder="城市" @change="ckshi" class="cty16">
                    <el-option
                    v-for="item in shilist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 排序：">
               <el-input placeholder="数字越大，排名越靠前（请输入正整数）" v-model="mydata.sortOrder" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 是否默认：">
                <el-radio v-model="mydata.isDefault" label=true>是</el-radio>
                <el-radio v-model="mydata.isDefault" label=false>否</el-radio>
            </el-form-item>
            <el-form-item label="* 是否热门：">
                <el-radio v-model="mydata.isHot" label=true>是</el-radio>
                <el-radio v-model="mydata.isHot" label=false>否</el-radio>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible=false">取 消</el-button>
            <el-button type="primary" @click="puton(2)">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext';
import Reset from "@/components/Reset";
import Paging from '@/components/Paging';
import Provinces from "@/components/Provinces";
export default {
  name: "keyword",
  components: {
    Xlsx,
    EditorBar,
    Reset,
    Paging,
    Provinces
  },
  data() {
    return {
        beginData:{},
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        userdata: {},
        total: 0,
        btn: [],
        fullscreenLoading: true,
        formname: JSON.stringify({name:'商品分类',hint:'keyword:export'}),
        sheng:'',
        shengName: '',
        shi:'',
        shenglist:[],
        shilist:[],
        mydata:{isDefault:'true',isHot:'true'},
        multipleSelection:[],
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem('region'))
    region.forEach(x => {
        if(x.level==0){
            this.shenglist.push(x);
            this.sheng=x.id;
            this.shengName=x.name;
        }
    });
    if(this.userdata.level==0){
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:region[0].id}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.$set(this,'shilist',res.data.areaListInfoList)
            }
        })
    }else{
        region.forEach(x=>{
            if(x.level==1){
                this.shilist.push(x)
                this.shi=x.id
                this.mydata.areasId = this.sheng +','+ x.id;
                this.mydata.areasName = this.shengName +','+ x.name;
            }
        })
    }

    this.dataClose();
  },
  methods: {
    resets(){
        this.$router.push('/refresh')
    },
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('keyword:add')==-1){
                return this.$message.error('抱歉，用户暂无该权限')
            }
            this.handleEdit(0)
        }else if(i==2){
            if(this.btn.indexOf('keyword:update')==-1){
                return this.$message.error('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message.error('请勾选一项内容编辑')
            }
            this.handleEdit(1,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('keyword:delete')==-1){
                return this.$message.error('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message.warning('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteKeyword/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    // 关闭清空内容
    dataClose(){
        if(this.shilist.length==1){
            this.mydata={isDefault:'true',isHot:'true',areasId:this.sheng +','+ this.shilist[0].id,areasName:this.userdata.areasName}
        }else{
            this.shi = ''
            this.mydata={isDefault:'true',isHot:'true'}
        }
        this.begin()
    },
    cksheng(val){
        this.$set(this,'shi','')
    },
    ckshi(val){
        this.mydata.areasId = this.sheng +','+ val
        let arr = []
        this.shenglist.forEach(x=>{
            if(this.sheng==x.id){
                arr.push(x.name)
            }
        })
        this.shilist.forEach(x=>{
            if(val==x.id){
                this.mydata.pinyin = x.pinyin
                arr.push(x.name)
            }
        })
        this.mydata.areasName = arr.join(',')
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   确定
    puton(){
        if(this.mydata.keyword == undefined || this.mydata.keyword == ""){
            return this.$message('请输入关键词')
        }
        if(this.mydata.areasId == undefined || this.mydata.areasId == "" || this.mydata.areasName == undefined || this.mydata.areasName == "" ){
            return this.$message('请选择或重新选择所属地区')
        }
        if(this.mydata.sortOrder == undefined || this.mydata.sortOrder == ""){
            return this.$message('请填写排序')
        }
        this.fullscreenLoading = true;
        // 判断是点击哪个
        let url = ``
        if(this.mydata.stat==0){
            url = `/api-s/addKeyword`
        }else if(this.mydata.stat==1){
            url = `/api-s/updateKeyword`
        }
        this.$axios.post(url,this.$qs.stringify(this.mydata),{ headers: { accessToken: this.userdata.token } })
        .then(res => {
            if(res.data.success){
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.dialogFormVisible = false
            }else{
                this.$message({
                    message:res.data.msg,
                    type: 'warning'
                })
            }
        });
    },
    // 获取省市传入的id
    gainSS(i){
        this.beginData.areaId = i.id
    },
    reset() {
      this.beginData = {}
      this.begin();
    },

    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin()
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        keyword:this.beginData.keyword,
        adminAreasId:this.userdata.areasId,
        areaId:this.beginData.areaId
      });
      this.$axios.post(`/api-s/getKeywordGoodsList`, data, {headers: { accessToken: userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message.error('抱歉，用户暂无该权限')
        }
        if(i == 0){
            this.mydata.stat = i
        }else if(i == 1){
            row.stat = i
            row.isDefault+=''
            row.isHot+=''
            this.sheng = Number(row.areasId.split(',')[0])
            this.shi = Number(row.areasId.split(',')[1])
            this.mydata = row
        }
        this.dialogFormVisible = true
    },
    // 删除
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let url = ``
          url = `/api-s/deleteKeyword/${row.id}`
          this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  this.begin();
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap: wrap;
}
#keyword .el-input__inner {
  margin: 10px 0;
}
.keyword .el-select{
    width: 100%;
}
#keyword .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#keyword .el-menu-item.is-active{
  background: none
}
#keyword .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#keyword .el-tag{
  margin-right: 12px;
}
#keyword .el-select {
  /* margin: 0 8px; */
}
#keyword .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#keyword .el-upload-list--picture .el-upload-list__item {
    /* float: left;
    margin-right: 2%; */
}
#keyword .el-form-item__content {
    width: 74%;
    display: flex;
}
#keyword .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#keyword .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#keyword .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#keyword .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#keyword .el-dialog__body {
  height: 100%;
}
#keyword .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#keyword .el-form-item__label{
    width: 150px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
</style>
